/** Message view (`?sel=msg:` selection) — the FULL, deep-linkable message page.
 *
 * Since F.3 the everyday "Open" affordance is the modal (`CrmMessageModal`), and this page is what
 * "Open full view ↗" inside it navigates to. It is deliberately NOT deleted: every `?sel=msg:N` link
 * already shared or bookmarked resolves here.
 *
 * The metadata header, the governed participant list (F.2 — external names link + hovercard, Ember
 * colleagues render as text) and the thread-aware body (F.4) all live in `CrmMessageDetail`, so the
 * page and the modal cannot drift — including in the awkward states (sealed subject, 403 "not on this
 * thread", 404 "no stored body"). */
import { CrmMessageDetail } from './CrmMessageDetail';
import type { OpenPerson } from './CrmParticipants';
import styles from './crm.module.css';

interface Props {
  emailId: number;
  onBack: () => void;
  /** In-place profile navigation for a linked participant. */
  openPerson?: OpenPerson;
}

export function CrmMessageView({ emailId, onBack, openPerson }: Props) {
  return (
    <>
      <button className={styles.backButton} onClick={onBack}>← Back</button>
      <div className={styles.cols}>
        <div>
          <CrmMessageDetail emailId={emailId} openPerson={openPerson} />
        </div>
        <div>
          <div className={styles.card}>
            <div className={styles.cardTitle}>About this view</div>
            <div className={styles.hint}>
              Every body read is re-gated and audited. Quoted history is collapsed for display only —
              the stored message is unchanged. Attachments are a later slice.
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
